import * as React from 'react'
import { Button, Form } from 'react-bootstrap'


import ExpenseLineItem from './ExpenseLineItem'

import { JobMode, parseFloatTotal } from '../Job'

import { copyObject, randomId } from '../../../../utils'
import * as _ from 'lodash'

import { VariablesObj } from '../../../../types/Company'
import CogsList from './CogsList'

import { useImmer } from 'use-immer'
import { AxiosInstance } from '../../../../utils/RequestMethods'
import config from '../../../../constants/config'
import { TransactionT } from '../../../../types/TransactionT';
import { RevenueList } from './RevenueList'
import { extractImpliedLineDate, getRevenueFromTrasactions } from '../JobUtils'
import { CogsLineItemT, ExpenseLineItemT, FinancialT, JobT, RevenueLineItemT, TypeFinancialT } from '../../../../types/Job'
import { CogsLineItemObj, ExpenseLineItemObj, FinancialObj, RevenueLineItemObj } from '../InitObjectJob'


interface FinancialTabProps {
  job: JobT
  jobMode: JobMode
  lineItemDate: string
  updateJob(key: string, value: any): void
  saveJob(): Promise<JobT>
  refreshJob(newJob: JobT): void
  tabIsActive: boolean
}

const style = {
  block: {
    marginBottom: 50
  }
}



const FinancialTab: React.FunctionComponent<FinancialTabProps> = (props): JSX.Element => {
  const [itemsPayment, setItemsPayment] = React.useState(null)
  const [financial, setFinancial] = React.useState(copyObject(FinancialObj));
  const [jobLocationsTemp, setJobLocationsTemp] = React.useState([])
  const [estimateTemp, setEstimateTemp] = React.useState([])
  const [companyVariables, setCompanyVariables] = React.useState(VariablesObj)
  const [transactions, setTransactions] = React.useState<Array<TransactionT>>([]);
  const [isReady, setIsReady] = React.useState(false);

  React.useEffect(() => {
    if (!_.isEqual(props.job.financial, financial) && props.jobMode == "edit") {
      getTransactions()
    }
  }, [props.job])


  // effect when update company
  React.useEffect((): void => {
    if (props.job?.companyInfo?.variables) {
      setCompanyVariables({ ...VariablesObj, ...props.job.companyInfo.variables })
    }
  }, [props?.job?.companyInfo])



  React.useEffect(() => {

    updateFromEffect(props.job, financial, "cogs")
    updateFromEffect(props.job, financial, "revenue")
    updateFromEffect(props.job, financial, "expenses")
  }, [props.job.financial]);


  /**
   *
   */
  const getTransactions = async (): Promise<void> => {
    // setTransactions([])
    let params = {
      // userId: props.job.client.id,
      productId: props.job.id,
      status: "complete",
      all: true,
    }
    let options = {
      data: params
    }
    AxiosInstance.get(`${config.url.jobs}/${props.job.id}/transactions`, options).then((res) => {
      if (res && res.data) {
        console.log("transactions", res.data)
        setTransactions(res.data)
      } else {
        setTransactions([])
      }
    }).catch((error) => {
      setTransactions([])
    })
  }


  const updateFromEffect = (job: JobT, financial: FinancialT, key: "cogs" | "revenue" | "expenses") => {
    if (!_.isEqual(job.financial[key], financial[key])) {
      setFinancial(draft => {
        draft[`${key}`] = job.financial[key]
        return draft
      })
    }
  }



  /**
   *
   * @returns
   */
  const generateNewLine = (impliedDate: string | null, lineItem: CogsLineItemT | ExpenseLineItemT | RevenueLineItemT): CogsLineItemT | ExpenseLineItemT | RevenueLineItemT => {
    let newLineItem = copyObject(lineItem)
    newLineItem.id = randomId()
    if (impliedDate != null)
      newLineItem.date = `${impliedDate}`
    return newLineItem
  }

  /**
   *
   * @param lineItemType
   */
  const addLineItem = (lineItemType: TypeFinancialT): void => {
    // extractImpliedLineDate(job)
    const impliedDate = extractImpliedLineDate(props.job)
    let financialClone = copyObject(financial)
    switch (lineItemType) {
      case 'revenue':

        let cloneRevenueObject = generateNewLine(impliedDate, RevenueLineItemObj)
        cloneRevenueObject.item = "deposit"
        financialClone.revenue.lineItems.push(cloneRevenueObject)
        break
      case 'cogs':
        //financialClone.cogs.isDirty = true
        let cloneObject = generateNewLine(impliedDate, CogsLineItemObj)
        cloneObject.item = "packingLabor"
        financialClone.cogs.lineItems.push(cloneObject)
        break
      case 'expenses':
        //financialClone.expenses.isDirty = true
        financialClone.expenses.lineItems.push(generateNewLine(impliedDate, ExpenseLineItemObj))
      default:
    }

    updateJobFinancial(financialClone)
  }


  const generateNewItem = (category: string) => {
    switch (category) {
      case 'revenue':
        return copyObject(RevenueLineItemObj)
      case 'cogs':
        return copyObject(CogsLineItemObj)
        break
      case 'expenses':
        return copyObject(ExpenseLineItemObj)
      default:
    }
  }



  const removeLineItem = (key: string, index: number): void => {
    let financialClone = copyObject(props.job.financial)
    let financialItem = financialClone[key]
    let lineItems = financialItem.lineItems
    //documentsClone.estimate.lineItems.splice(index, 1)
    const filteredItems = lineItems.slice(0, index).concat(lineItems.slice(index + 1, lineItems.length))

    if (filteredItems.length <= 0) {
      let item = generateNewItem(key)
      filteredItems.push(item)
    }
    financialItem.isDirty = true
    financialItem.lineItems = copyObject(filteredItems);
    financialClone[key] = copyObject(financialItem)
    updateJobFinancial(financialClone)
  }

  const sumTotal = (lineItems: Array<CogsLineItemT | ExpenseLineItemT | RevenueLineItemT>): number => {
    if (lineItems.length == 0) return 0
    let lineItem = lineItems.shift()
    let total = 0
    if (lineItem.item == 'discount') total = sumTotal(lineItems) - Number(parseFloat(`${lineItem.total}`).toFixed(2))
    else total = Number(parseFloat(`${lineItem.total}`).toFixed(2)) + sumTotal(lineItems)
    return parseFloat(`${parseFloatTotal(total)}`)
  }

  /**
   *
   * @param key
   * @param index
   * @param lineItem
   */
  const updateLineItem = (key: string, index: number, lineItem: CogsLineItemT | ExpenseLineItemT | RevenueLineItemT): void => {
    let financialClone = copyObject(financial)
    let financialItem = copyObject(financialClone[key])
   
    financialItem.lineItems[index] = lineItem
    financialClone[key] = copyObject(financialItem)
    updateJobFinancial(financialClone)
  }

  const updateJobFinancial = (financialClone): void => {
    setFinancial(draft => {
      draft = financialClone
      return draft
    })
    props.updateJob('financial', copyObject(financialClone))
  }


  /**
   *
   * @param key
   * @param value
   */
  const updateFinancial = (key: string, value: any) => {
    let financialClone = copyObject(financial)
    financialClone[key] = value
    updateJobFinancial(financialClone)
  }


  /**
   *
   * @param financial
   */
  const getTotal = (financial) => {
    let revenuItems = financial.revenue && _.has(financial, "revenue.lineItems") ? copyObject(financial.revenue.lineItems) : []

    let revenueFromTrasactions = getRevenueFromTrasactions(revenuItems, Array.isArray(transactions) ? transactions : [])
    //@ts-ignore
    revenuItems = _.uniq(revenuItems, revenueFromTrasactions)
    let expensesItems = financial.expenses && financial.expenses.lineItems ? copyObject(financial.expenses.lineItems) : []
    let cogsItems = financial.cogs && financial.cogs.lineItems ? copyObject(financial.cogs.lineItems) : []
    const totalRevenuItems = sumTotal(revenuItems)
    const totalexpensesItems = sumTotal(expensesItems)
    const totalcogsItems = sumTotal(cogsItems)
    console.log("totalRevenuItems", totalRevenuItems)
    const total = totalRevenuItems - totalexpensesItems - totalcogsItems
    // console.log("total", total)
    return parseFloatTotal(total)
  }

  const handleSaveJob = async (): Promise<string> => {
    // const jobPayments = copyObject(job.payments)
    // updateJob('payments', jobPayments)

    try {
      let data = await props.saveJob();
      if (data) {
        setTimeout(() => {
          props.refreshJob(data)
        }, 2000);
        let msg = ''
        return msg;
      }
    } catch (error) {
      console.log("error", error)
      throw new Error("can't open payment page  , please try again  ");
    }
  }



  // const revenuItems = financial.revenue && financial.revenue.lineItems ? copyObject(financial.revenue.lineItems) : []
  const expensesItems = financial.expenses && financial.expenses.lineItems ? copyObject(financial.expenses.lineItems) : []
  // const cogsItems = financial.cogs && financial.cogs.lineItems ? copyObject(financial.cogs.lineItems) : []

  if (!props.tabIsActive) {
    return null
  }

  return (
    <div className='p-1'>

      <div style={style.block}>

        <RevenueList
          jobMode={props.jobMode}
          job={props.job}
          financial={financial}
          sumTotal={sumTotal}
          addLineItem={addLineItem}
          removeLineItem={removeLineItem}
          updateLineItem={updateLineItem}
          updateFinancial={updateFinancial}
          companyVariables={companyVariables}
          transactions={transactions}
          saveJob={handleSaveJob}
          refresh={async (): Promise<void> => {
            return await getTransactions()
          }}
        />
      </div>
      <div style={style.block}>
        <CogsList
          job={props.job}
          financial={financial}
          sumTotal={sumTotal}
          updateFinancial={updateFinancial}
          addLineItem={addLineItem}
        />
      </div>
      <div style={style.block}>
        <h4>Expenses</h4>
        {_.isArray(financial?.expenses?.lineItems) && financial?.expenses?.lineItems.map((lineItem: ExpenseLineItemT, index: number): JSX.Element => {
          return (
            <ExpenseLineItem
              key={index}
              index={index}
              job={props.job}
              expenseLineItem={lineItem}
              removeLineItem={removeLineItem}
              updateLineItem={updateLineItem} />
          )
        })}
        <span style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 30px' }}>
          <span>
            <Button
              onClick={(): void => { addLineItem('expenses') }}
              variant='light'>
              Add Line Item
            </Button>
          </span>
          <span></span>
          <span></span>
          <span></span>
          <span>
            <Form.Label><strong>Total, $</strong></Form.Label>
            <Form.Control
              className='input-material'
              disabled
              value={`${parseFloatTotal(sumTotal(expensesItems))}`} />
          </span>
        </span>
      </div>
      <div style={style.block}>
        <span style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 30px' }}>
          <h4>Net Profit</h4>
          <span></span>
          <span></span>
          <span></span>
          <span>
            <Form.Label><strong>Total, $</strong></Form.Label>
            <Form.Control
              className='input-material'
              disabled
              value={`${getTotal(financial)}`} />
          </span>
        </span>
      </div>
    </div>
  )
}

export default React.memo(FinancialTab)
